module.exports = __webpack_public_path__ + "static/media/allowcamera.01fbdb3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/allowcamera.png
// module id = 135
// module chunks = 1